/* 云途 数据字典 */
// 客户类型
export const customerTypeEnum = [
  {
    value: 3,
    label: '大陆个人'
  },
  {
    value: 4,
    label: '大陆公司'
  },
  {
    value: 5,
    label: '香港公司'
  },
  {
    value: 6,
    label: '海外公司'
  }
]
// 业务类型
export const businessTypeEnum = [
  {
    value: 1,
    label: 'B2B'
  },
  {
    value: 2,
    label: 'B2C'
  },
]
// 联系方式
export const linkMethods = [
  {
    value: 1,
    label: '手机号'
  },
  {
    value: 3,
    label: '邮箱'
  },
  {
    value: 5,
    label: 'qq'
  },
  {
    value: 4,
    label: '微信号'
  },
  {
    value: 2,
    label: '固定电话'
  }
]
// 收藏筛选状态
export const favoriteStatus = [
  {
    label: '默认',
    value: 0
  },
  {
    label: '收藏优先',
    value: 1
  },
  {
    label: '仅看收藏',
    value: 2
  }
]
// 线索阶段
export const clueStatusEnum = [
  {
    value: 3,
    label: '跟进中'
  },
  {
    value: 8,
    label: '已转化'
  },
  {
    value: 5,
    label: '无效线索'
  }
]
// 客户阶段  2潜在客户阶段；3签约客户阶段；8成交客户
export const customerPhaseEnum = [
  {
    value: 2,
    label: '潜在客户'
  },
  {
    value: 4,
    label: '成交客户'
  }
]
// 客户阶段  2潜在客户阶段；3签约客户阶段；8成交客户
export const clueAndcustomerPhaseEnum = [{
  label: '线索阶段',
  value: 1
}, ...customerPhaseEnum]
// 潜在客户状态
export const potentialStatusEnum = [
  {
    value: 10,
    label: '谈判',
    desc: '一切协商、交涉、商量、磋商等',
    color: '#EF8D3C'
  },
  {
    label: '已注册',
    value: 11,
    desc: '已在官网进行注册系',
    color: '#EF8D3C'
  },
  {
    label: '暂无法合作',
    value: 13,
    desc: '客户目前拒绝',
    color: '#DF443B'
  }
]

export const clientsEditStatusEnum = [{
  label: '上涨',
  value: 32,
  desc: '业务量上涨的客户',
  color: '#EF8D3C'
},
{
  label: '下降',
  value: 33,
  desc: '业务量下降的客户',
  color: '#EF8D3C'
},
{
  label: '稳定',
  value: 34,
  desc: '业务量稳定的客户',
  color: '#EF8D3C'
},
{
  label: '流失',
  value: 36,
  desc: '停止合作的客户',
  color: '#DF443B'
}]

// 成交客户状态
export const clientsStatusEnum = [
  {
    label: '已签约',
    value: 30,
    desc: '已完成签约的客户',
    color: '#EF8D3C'
  },
  {
    label: '首次发件',
    value: 37,
    desc: '首次发件的客户',
    color: '#EF8D3C'
  },
  {
    label: '本年度新客户',
    value: 38,
    desc: '本年度新客户',
    color: '#EF8D3C'
  },
  {
    label: '激活客户',
    value: 39,
    desc: '激活客户',
    color: '#EF8D3C'
  },
  ...clientsEditStatusEnum
]

// 客户未跟进天数
export const customerUnfollowDayTypeEnum = [
  {
    value: 1,
    label: '3天以内'
  },
  {
    value: 2,
    label: '7天以内'
  },
  {
    value: 3,
    label: '15天以内'
  },
  {
    value: 4,
    label: '30天以内'
  },
  {
    value: 5,
    label: '60天以内'
  },
  {
    value: 6,
    label: '90天以内'
  },
  {
    value: 7,
    label: '超过90天'
  }
]
// tms客户标签
export const tmsCustomerValueEnum = {
  O: '草稿',
  L: '锁定',
  C: '正式',
  I: '已作废'
}
// 剩余跟进天数类型 超时（小于0天）、3天以内（0-3天）、7天以内、15天以内、超过15天
export const remanentFollowDayTypeEnum = [
  {
    value: 5,
    label: '超时'
  },
  {
    value: 1,
    label: '3天以内'
  },
  {
    value: 2,
    label: '7天以内'
  },
  {
    value: 3,
    label: '15天以内'
  },
  {
    value: 4,
    label: '超过15天'
  }
]
// 商机剩余变更时间
export const remanentBusinessDayTypeEnum = [
  {
    value: 1,
    label: '超时'
  },
  {
    value: 2,
    label: '3天以内'
  },
  {
    value: 3,
    label: '7天以内'
  },
  {
    value: 4,
    label: '15天以内'
  },
  {
    value: 5,
    label: '超过15天'
  }
]
//
export const flagEnum = [
  {
    value: 1,
    label: '是'
  },
  {
    value: 0,
    label: '否'
  }
]
export const enterpriseScaleEnum = [
  {
    value: 1,
    label: '1~100人'
  },
  {
    value: 2,
    label: '100~500人'
  },
  {
    value: 3,
    label: '500~1000人'
  },
  {
    value: 4,
    label: '1000人以上'
  }
]
export const contactTypeEnum = [
  {
    value: 2,
    label: '法人'
  },
  {
    value: 3,
    label: '收货人'
  }
]
export const customerAllStatusEnum = [
  {
    label: '线索公海池',
    value: 0
  },
  {
    label: '待领取',
    value: 1
  },
  {
    label: '待跟进',
    value: 2
  },
  {
    label: '跟进中',
    value: 3
  },
  {
    label: '无效线索',
    value: 5
  },
  {
    label: '未来线索',
    value: 6
  },
  {
    label: '已转换',
    value: 8
  },
  {
    label: '谈判',
    value: 10
  },
  {
    label: '已注册',
    value: 11
  },
  {
    label: '暂无法合作',
    value: 13
  },
  {
    label: '归档',
    value: 14
  },
  {
    label: '已签约',
    value: 30
  },
  {
    label: '上涨',
    value: 32
  },
  {
    label: '下降',
    value: 33
  },
  {
    label: '稳定',
    value: 34
  },
  {
    label: '流失',
    value: 36
  },
  {
    label: '首次发件',
    value: 37
  },
  {
    label: '本年度新客户',
    value: 38
  },
  {
    label: '激活客户',
    value: 39
  }
]
// 性别
export const genderEnum = [
  {
    value: 1,
    label: '男'
  },
  {
    value: 2,
    label: '女'
  }
]
/* 联系人角色类型 */
export const linkRoleTypeEnum = [
  {
    value: 1,
    label: '影响者'
  },
  {
    value: 2,
    label: '决策者'
  },
  {
    value: 3,
    label: '使用者'
  }
]
// 商机状态
export const businessStatusEnum = [
  {
    label: '01-潜力商机',
    value: 0,
    color: '#EF8D3C',
    disabled: false,
    desc: '潜力商机'
  },
  {
    // label: '初步初步接洽接洽(1ST MEETING)',
    label: '02-首次接触',
    value: 1,
    color: '#EF8D3C',
    disabled: false,
    desc: '已经同客户取得第一次沟通或拜访，了解客户基础情况，需进一步了解客户需求，获取机会情况'
  },
  {
    // label: '谈判沟通(PROPOSAL)',
    label: '03-提供方案&谈判',
    value: 2,
    color: '#EF8D3C',
    disabled: false,
    desc: '已了解客户需求，匹配云途资源与解决方案，量化价值，拟定意向价格；展示解决方案及产品，解决客户疑虑与问题'
  },
  // {
  //   // label: '签订合同(SIGN AGREEMENT)',
  //   label: '签约',
  //   value: 4,
  //   color: '#EF8D3C',
  //   disabled: false,
  //   // desc: '合同签署，方案实施，客户培训，应对竞争者反映'
  //   desc: '合同签署'
  // },
  {
    label: '04-签约&准备发件',
    value: 9,
    color: '#EF8D3C',
    disabled: false,
    desc: '签约&准备发件，方案实施，客户培训，应对竞争者反映'
  },
  {
    // label: '第一次发件(1ST SHIPMENT)',
    label: '05-首次发件',
    value: 5,
    color: '#EF8D3C',
    disabled: false,
    // desc: '开始发货与合作，寻找新的机会'
    desc: '开始发货'
  },
  {
    // label: '达到承诺业务量(SHIPPING TO PROFILE)',
    label: '06-达到承诺业务量',
    value: 7,
    color: '#3FAC46',
    disabled: false,
    // desc: '商机转化达到基础百分比（50%） '
    desc: '客户平均发货量达到该商机录入的承诺发货量'
  },
  {
    // label: '不能合作(UNABLE TO GAIN)',
    label: '07-不能合作',
    value: 6,
    color: '#DF443B',
    disabled: false,
    desc: '该商机不能达成合作'
  },
  {
    // label: '未来机会(FUTURE OPPORTUNITIES)',
    label: '08-未来机会',
    value: 8,
    color: '#EF8D3C',
    disabled: false,
    desc: '该商机暂时不能合作，未来存在合作可能性，90天内需要重新联系更新商机'
  }
]
// 商机变更情况类型枚举
export const chanceModifiesTypeEnum = [
  { label: 'OCR金额', value: 1 },
  { label: 'OCR票数', value: 2 },
  { label: 'OPR金额', value: 3 },
  { label: 'OPR票数', value: 4 }
]

// export const b2bProductIds = ['3600', '3601', '3602', '3603', '3604', '3605', '3606', '3607', '3608', '3609', '3610']

// export const ifB2BProduct = (id: any) => {
//   if (!id) return false
//   return b2bProductIds.includes(id.toString())
// }

/* 结算模式 */
export const settlementTypeEnum = [
  { label: '预付', value: 'P' },
  { label: '半月结', value: 'H' },
  { label: '月结', value: 'M' },
  { label: '现结', value: 'C' },
  { label: '周结', value: 'W' }
]


export default {
  customerTypeEnum,
  linkMethods,
  customerPhaseEnum,
  clueAndcustomerPhaseEnum,
  potentialStatusEnum,
  clientsStatusEnum,
  clientsEditStatusEnum,
  customerUnfollowDayTypeEnum,
  flagEnum,
  enterpriseScaleEnum,
  contactTypeEnum,
  genderEnum,
  linkRoleTypeEnum,
  businessStatusEnum,
  remanentFollowDayTypeEnum,
  customerAllStatusEnum,
  tmsCustomerValueEnum,
  remanentBusinessDayTypeEnum,
  favoriteStatus,
  chanceModifiesTypeEnum,
  businessTypeEnum,
  // ifB2BProduct,
  // b2bProductIds,
  settlementTypeEnum
}
